import axios from 'axios';
import configuration from './configuration.service';
import auth from '@sonifi/wb-login/services/oauth.service';
import { isAuthenticated } from '@sonifi/wb-login/services/keyMaster.service';

export const authInterceptor = function (config) {
  const options = configuration.get('oauthCredentials');
  const url = axios.getUri(config).replace('#', '%23');

  if (isAuthenticated() && url.startsWith(configuration.get('apiUri'))) {
    // const sendBody =
    //   _.has(config.headers[config.method], 'Content-Type') &&
    //   config.headers[config.method]['Content-Type'] &&
    //   config.headers[config.method]['Content-Type'].indexOf(
    //     'application/x-www-form-urlencoded',
    //   ) !== -1;
    // const hasBody = sendBody && config.data;

    const authHeaders = auth.buildOAuthHeader(
      config.method.toUpperCase(),
      url,
      false, // sendBody and hasBody need to be reviewed
      options,
    );

    config.headers.Authorization = authHeaders;
    config.url = config.url.replace('#', '%23');
    return config;
  }
  return config;
};
